import adAccountCRUDActions from '../actions/AdAccountCRUDActions';
import Actions from '../actions/actions';
import { retrieved, setBusy, setUnBusy } from './common/commonReducers';
import { AdAccountsState } from '../interfaces/adAccounts';
import AdAccountModel from '../model/AdAccountModel';
import { unionBy } from 'lodash';

const initialState: AdAccountsState = {
  busy: false,
  entities: [],
  next: '',
};

const unionUniqueById = (
  prevEntities: AdAccountModel[],
  nextEntities: AdAccountModel[],
) => unionBy(nextEntities, prevEntities, 'id');

const retrievedAll = (state: AdAccountsState, action): AdAccountsState => {
  const { entities: nextEntities, next } = action;
  const { entities: prevEntities } = state;
  const entities = unionUniqueById(prevEntities, nextEntities);
  return {
    ...state,
    next,
    entities,
    busy: false,
  };
};

export default function adInsight(
  state: AdAccountsState = initialState,
  action,
): AdAccountsState {
  switch (action.type) {
    case adAccountCRUDActions.retrievedAction:
      return retrieved(state, action);
    case adAccountCRUDActions.busyAction:
      return setBusy(state);
    case adAccountCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case adAccountCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
